<template>
  <div class="page-content">
    <template v-if="!isMobileAds">
      <!-- <ad :ad-object="firstAd" :no-margin="hideFirstDesktopAd" v-on:ad-loaded="updateAdsListForPage"></ad> -->
      <p class="has-text-centered" style="margin-top: 150px;">
        <fuse-ad name="industries_header" v-on:ad-loaded="updateAdsListForPage"></fuse-ad>
        <!-- <ad :ad-object="secondAd" v-on:ad-loaded="updateAdsListForPage"></ad> -->
      </p>
    </template>
    <template v-else>
      <p class="has-text-centered">&nbsp;</p>
      <p class="has-text-centered">
        <fuse-ad name="industries_header" v-on:ad-loaded="updateAdsListForPage"></fuse-ad>
        <!-- <ad :ad-object="firstAd" :no-margin="hideFirstDesktopAd" v-on:ad-loaded="updateAdsListForPage"></ad> -->
      </p>
    </template>

    <div class="hp-container">
      <div class="hp-heading" :class="{'font-size-18': isMobile, 'has-text-centered': isMobile, 'font-size-32': isDesktop, 'font-size-24': isTablet}">Find and compare the best businesses on Hellopeter</div>
      <template v-if="!isMobileAds">
        <p class="has-text-centered">
          <fuse-ad name="industries_incontent_1" v-on:ad-loaded="updateAdsListForPage"></fuse-ad>
          <!-- <ad :ad-object="thirdAd" v-on:ad-loaded="updateAdsListForPage"></ad> -->
        </p>
      </template>
      <template v-else>
        <p class="has-text-centered">
          <fuse-ad name="industries_incontent_1" v-on:ad-loaded="updateAdsListForPage"></fuse-ad>
          <!-- <ad :ad-object="secondAd" v-on:ad-loaded="updateAdsListForPage"></ad> -->
        </p>
      </template>
      <div class="container-box">
        <loader v-if="isFetchingIndustries" />
        <BulmaAccordion v-else-if="isMobile" id="industriesAccord" :caretAnimation="{
            duration: '.2s',
            timerFunc: 'ease-in-out',
          }" :dropdown="true" :icon="'custom'" :slide="{
        duration: '.2s',
        timerFunc: 'ease',
      }" class="is-hidden-tablet">
          <BulmaAccordionItem v-for="(industry, index) in industriesWithoutAll" :key="index">
            <div slot="title" class="font-size-12 color-blue-dark has-text-weight-normal"><span @click="openIndustryDetail($event, industry.slug)">{{
                industry.name
              }}</span></div>
            <template v-if="industry.sub_industries.length"><img slot="icon-closed" alt="Open accordion"
                                                                 src="/static/img/arrows/arrow_right_blue_dark.svg"/>
              <img slot="icon-open" alt="Close accordion" src="/static/img/arrows/arrow_down_blue_dark.svg"
                   style="max-width: none"/>
              <div slot="content">
                <router-link :to="{ name: 'Industries-Category', params: { slug: industry.slug } }"
                             class="pill">
                  All
                </router-link>
                <router-link v-for="(subIndustry, subIndustryIndex) in industry.sub_industries" :key="subIndustryIndex"
                             :to="{ name: 'SubIndustriesDetail', params: { indSlug: industry.slug, subIndSlug: subIndustry.slug } }"
                             class="pill">
                  {{ subIndustry.name }}
                </router-link>
              </div>
            </template>
          </BulmaAccordionItem>
        </BulmaAccordion>
        <template v-else>
          <div v-for="(industry, index) in industriesWithoutAll" :key="index" class="columns">
            <div class="column indCol">
              <router-link :to="{ name: 'Industries-Category', params: { slug: industry.slug } }"
                           class="color-blue-dark indLink">
                {{ industry.name }}
              </router-link>
            </div>
            <div class="column subIndCol">
              <router-link :to="{ name: 'Industries-Category', params: { slug: industry.slug } }" class="pill">All
              </router-link>
              <router-link v-for="(subIndustry, subIndustryIndex) in industry.sub_industries" :key="subIndustryIndex"
                           :to="{ name: 'SubIndustriesDetail', params: { indSlug: industry.slug, subIndSlug: subIndustry.slug } }"
                           class="pill">
                {{ subIndustry.name }}
              </router-link>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import {BulmaAccordion, BulmaAccordionItem} from 'vue-bulma-accordion'
import {misc, adConfig, industries} from '@/mixins'
import {Loader, Ad, FuseAd} from '@/components'

export default {
  name: 'IndustryList',
  components: {
    BulmaAccordion,
    BulmaAccordionItem,
    Ad,
    FuseAd,
    Loader
  },
  mixins: [adConfig, misc, industries],
  metaInfo() {
    return {
      title: 'Industries | Customer Service & Company Ratings | hellopeter.com',
      bodyAttrs: {
        class: 'industries'
      },
      meta: [
        {
          name: 'description',
          content: 'Use Hellopeter to find and compare the best industries in South Africa. From Cape Town to Johannesburg, our reviews help you find the most trusted businesses online.'
        }
      ],
      links: [
        {rel: 'canonical', href: `${window.location.protocol}//${window.location.host}${this.$route.path}`}
      ]
    }
  },
  computed: {
    carouselAndIndustries() {
      const industryLength = this.industriesWithoutAll.length
      const industryLoaded = parseInt(this.hasIndustriesFetched)
      return `${industryLength},${industryLoaded}`
    }
  },
  mounted() {
    this.$gtm.trackEvent({
      event: 'pageLoad',
      virtualPageUrl: this.$router.currentRoute.path,
      virtualPageTitle: 'Industries',
      brandName: '',
      industryName: ''
    })
    // this.loadFuseAds()
    // this.loadAds()
  },
  methods: {
    openIndustryDetail(e, slug) {
      e.stopPropagation()
      e.stopImmediatePropagation()
      this.$router.push({name: 'Industries-Category', params: {slug}})
    }
  },
  watch: {
    carouselAndIndustries() {
      window.prerenderReady = true
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";
@import "@/assets/scss/vendor/_breakpoints.scss";

@include not-desktop {
  .page-content {
    padding: 0 9px 0 11px;
  }
}

.hp-container {
  margin: 41px auto 11px;

  .container-box {
    border-radius: 5px;
    border: 1px solid rgba(88, 89, 91, 0.32);
    padding: 16px 6px 0 18px;
    margin-top: 11px;
  }
}

@media screen and (max-width: 768px) {
  #industriesAccord {
    margin-left: 6px;
  }

  #industriesAccord >>> .card {
    box-shadow: none;
    margin-bottom: 18px;
  }

  #industriesAccord >>> .card-header {
    box-shadow: none;
  }

  #industriesAccord >>> .card-header-title {
    font-weight: 600;
    padding: 0;
  }

  #industriesAccord >>> .card-header-icon {
    padding-top: 0;
    padding-bottom: 0;
    padding-right: 0;
    margin-right: 0 !important;
  }

  #industriesAccord >>> .card-content {
    background: none;
    padding: 6px 0 0;
  }
}

@media screen and (min-width: 768px) {
  .hp-container {
    margin-bottom: 59px;

    .container-box {
      border-radius: 10px;
      margin-top: 33px;
      padding: 12px 18px 39px;

      .columns:last-child .subIndCol {
        border: none;
      }
    }
  }

  .indCol {
    max-width: 264px;
  }

  .indLink {
    padding-top: 18px;
    display: inline-block;
    font-weight: 600;
  }

  .subIndCol {
    border-bottom: 1px solid rgba(88, 89, 91, 0.32);
    margin-right: 12px;
    padding-left: 0;
    padding-bottom: 9px;
    padding-top: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/industries/IndustryList.vue